<template>
  <div class="flex flex-col h-full pb-10">
    <div data-v-f88ad184="">
      <h1 class="thankyou-stagger thankyou-stagger--1 text-center text-lg text-base mb-5 font-medium" data-v-f88ad184="">Thank You!</h1>
      <div class="thankyou-stagger thankyou-stagger--2 bg-blue text-center text-white py-3 text-lg font-medium">Thank you for your donation of ${{donationAmountForView}}</div>
      <h2 class="thankyou-stagger thankyou-stagger--3 text-center text-xl font-bold my-3">Help spread the word!</h2>
      <p class="thankyou-stagger thankyou-stagger--4 text-center text-xl font-font-medium px-7">1 out of 4 people you share this with will also donate.</p>

      <div class="thankyou-stagger thankyou-stagger--5 flex space-y-3 flex-col items-center mt-3">
        
        <s-facebook
          :window-features="windowFeatures"
          :share-options="facebookShareOptions"
          @popup-close="onClose"
          @popup-open="onOpen"
          @popup-block="onBlock"
          @popup-focus="onFocus"
        >
          <span class="isolate inline-flex rounded-md">
            <button type="button" class="relative inline-flex items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 bg-facebook-100 hover:bg-facebook-200">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="w-4 h-4 text-white">
                <path fill="currentColor" d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"></path>
              </svg>
            </button>
            <button type="button" class="relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 rounded-r-md w-40">Share on Facebook</button>
          </span>
        </s-facebook>
        <s-twitter
          :window-features="windowFeatures"
          :share-options="twitterShareOptions"
          @popup-close="onClose"
          @popup-open="onOpen"
          @popup-block="onBlock"
          @popup-focus="onFocus"
        >
          <span class="isolate inline-flex rounded-md">
            <button type="button" class="relative inline-flex items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 bg-blue hover:bg-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4 h-4 text-white">
              <path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/>
            </svg>
            </button>
            <button type="button" class="relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 rounded-r-md w-40">Share on Twitter</button>
          </span>
        </s-twitter>
        <s-linked-in
          :window-features="windowFeatures"
          :share-options="linkedinShareOptions"
          @popup-close="onClose"
          @popup-open="onOpen"
          @popup-block="onBlock"
          @popup-focus="onFocus"
        >
          <span class="isolate inline-flex rounded-md">
            <button type="button" class="relative inline-flex items-center rounded-l-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 bg-blue-500 hover:bg-blue-700">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 h-4 text-white">
              <path fill="currentColor" d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/>
            </svg>
            </button>
            <button type="button" class="relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 rounded-r-md w-40">Share on Linkedin</button>
          </span>
        </s-linked-in>
        <s-email
          :share-options="emailShareOptions"
          @popup-close="onClose"
          @popup-open="onOpen"
          @popup-block="onBlock"
          @popup-focus="onFocus"
        >
          <span class="isolate inline-flex rounded-md">
            <button type="button" class="relative inline-flex items-center rounded-l-md border border-pink px-4 py-2 text-sm font-medium focus:z-10 focus:outline-none focus:ring-2 focus:ring-pink-100 bg-pink hover:bg-pink-600 text-white">
              <i class="fas fa-envelope" aria-hidden="true"></i>
            </button>
            <button type="button" class="relative -ml-px inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-pink-400 focus:outline-none focus:ring-2 focus:ring-pink-100 rounded-r-md w-40">Share via Email</button>
          </span>
        </s-email>
      </div>

      <p
        v-if="secondsRemaining > 0 && secondsRemaining < 10 && donationWidgetState.occurrence !== 'monthly'"
        class="mt-4 text-center text-xs text-gray-400"
        aria-live="polite"
      >
        This window will close in {{ secondsRemaining }}&nbsp;second{{ secondsRemaining === 1 ? '' : 's' }}.
      </p>
    </div>
  </div>
</template>

<script>
  import BigNumber from 'bignumber.js'
  import { SFacebook, STwitter, SLinkedIn, SEmail } from 'vue-socials';
  /* global process */

  /**
   * On recurring monthly donations the donation is created by a webhook so we will not have a donation id
   * thus the logic surrounding the occurrence conditions
   */
  export default {
    name: 'thank-you',

   components: { SFacebook, STwitter, SLinkedIn, SEmail },

    data() {
      return {
        // Countdown mirrors MakeDonationWidget.resetTimeout's 10s auto-close
        // for thank-you. Pure local timer; doesn't drive the actual close.
        secondsRemaining: 10,
        _countdownInterval: null,
      }
    },

    mounted() {
      // Only show countdown on non-monthly (which is the only path that
      // auto-closes in MakeDonationWidget).
      if (this.donationWidgetState.occurrence === 'monthly') return
      this._countdownInterval = setInterval(() => {
        if (this.secondsRemaining > 0) this.secondsRemaining--
      }, 1000)
    },

    beforeUnmount() {
      if (this._countdownInterval) clearInterval(this._countdownInterval)
    },

    created() {
      if (process.env.NODE_ENV !== 'production' || this.donationWidgetState.occurrence === 'monthly') {
        return
      }
      // Post to 360MatchPro (Double-the-Donation) for employer-match
      // tracking. Wrapped in try/catch with nil-guards because any of
      // (a) missing successfulTransactionData, (b) missing nested
      // double_the_donation object, (c) the doublethedonation global
      // not being loaded will otherwise throw from created() and block
      // the whole ThankYou component from mounting — leaving the donor
      // on a blank step 5. The tracking call is a side-effect; failure
      // should never prevent the thank-you card from rendering.
      try {
        const tx = this.donationWidgetState.successfulTransactionData
        if (!tx || !tx.double_the_donation) return
        if (typeof doublethedonation === 'undefined') return
        doublethedonation.integrations.core.register_donation({
          '360matchpro_public_key': 'M2JlZmUwZDQtYjRm',
          campaign: 'double-the-donation',
          donation_identifier: String(tx.id),
          donation_amount: String(tx.amount),
          donor_first_name: tx.first_name,
          donor_last_name: tx.last_name,
          donor_email: tx.email,
          doublethedonation_company_id: tx.double_the_donation.doublethedonation_company_id,
          doublethedonation_status: tx.double_the_donation.doublethedonation_status,
        })
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('ThankYou: 360MatchPro register_donation failed', err)
      }
    },
    computed: {
      facebookShareOptions() {
        return {
          url: this.campaignUrl,
          quote: this.facebookText,
          hashtag: '#WeWontIgnoreStageIV',
        };
      },
      twitterShareOptions() {
        return {
          url: this.campaignUrl,
          text: this.twitterText,
          hashtags: ['DigPink', 'MBC'],
        };
      },
      linkedinShareOptions() {
        return {
          url: this.campaignUrl,
          title: 'Custom LinkedIn Title',
          description: 'Custom LinkedIn Description',
        };
      },
      emailShareOptions() {
        return {
          subject: 'Custom Email Subject',
          body: `Custom Email Body: ${this.campaignUrl}`,
        };
      },
      donationWidgetState() {
        return this.$store.getters.donationWidget
      },
      calculatedFee() {
        const fixedFee = '30' // in cents
        const percentageFee = new BigNumber(0.022) // percentage
        const one = new BigNumber(1)
        const goal = new BigNumber(this.donationWidgetState.amount)
        const calculatedCharge = goal.plus(fixedFee).dividedBy(one.minus(percentageFee))
        return BigNumber(calculatedCharge.minus(goal))
      },
      
      calculatedTotal() {
        const amount = new BigNumber(this.donationWidgetState.amount)
        if (this.donationWidgetState.paidForTransactionFee) {
          return BigNumber(amount.plus(this.calculatedFee))
        }
        return amount
      },
      
      donationAmountForView() {
        return new BigNumber(this.calculatedTotal).dividedBy(100).toFormat(2)
      },
      receiptUrl() {
        if (this.donationWidgetState.occurrence === 'monthly') {
          return ''
        }

        return `/donation-receipt/${this.donationWidgetState.successfulTransactionData.invoice_id}`
        return `${process.env.MIX_APP_URL}/donation-receipt/${this.donationWidgetState.successfulTransactionData.invoice_id}`
      },
      facebookText() {
        return 'Support ' + 'Campaign Name' + ' and our efforts to raise funds for game changing stage IV breast cancer research. ' + this.campaignUrl + ' #WeWontIgnoreStageIV'
      },
      twitterText() {
        return 'Help support our #DigPink campaign & game-changing #MBC research!'
      },
      linkedInText() {
        return 'Help support our #DigPink campaign & game-changing #MBC research!'
      },
      campaignUrl() {
        return `${process.env.MIX_APP_URL}/campaigns/${this.donationWidgetState.campaignId}?donated=true`
      },
    },
    
    methods: {
      onClose() {},
      onOpen() {},
      onBlock() {},
      onFocus() {},
    },

  }
</script>

<style scoped>
  hr {
    margin: 15px 0 !important;
  }

  #donate h1 {
    margin-top: 5px !important;
  }

  /* Staggered reveal: the thank-you moment is the payoff of the flow,
     so the panel's elements enter in sequence rather than all at once.
     Pure CSS — no extra JS or transitions needed. */
  .thankyou-stagger {
    opacity: 0;
    animation: thankyou-stagger-in 420ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
  .thankyou-stagger--1 { animation-delay: 0ms; }
  .thankyou-stagger--2 { animation-delay: 80ms; }
  .thankyou-stagger--3 { animation-delay: 180ms; }
  .thankyou-stagger--4 { animation-delay: 260ms; }
  .thankyou-stagger--5 { animation-delay: 340ms; }

  @keyframes thankyou-stagger-in {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (prefers-reduced-motion: reduce) {
    .thankyou-stagger {
      animation-duration: 120ms !important;
      animation-delay: 0ms !important;
    }
  }
</style>
